export default __webpack_public_path__ + "static/media/ascend_arena.e9e0f55b.png";